import React from 'react';
import PropTypes from 'prop-types'

const Button = ({ type, name, classes, value, disabled, style }) => {

  return (
    <button
      type={type}
      name={name}
      disabled={disabled}
      className={classes}
      style={style}
    >
    {value}
    </button>
  );
}

Button.propTypes = {
  value: PropTypes.string.isRequired
}

Button.defaultProps = {
  type: 'submit',
  value: 'JETZT ANMELDEN',
  disabled: false
}

export default Button
